import { cn } from '@/lib/utils.ts'

import { Badge } from '@/components/ui/badge.tsx'
import { Button } from '@/components/ui/button.tsx'
import { GlobalPubSub } from '@/utils/pubsub.ts'

export const StoryLabel = ({ item, onRemove, variant, isHighlighted, className }: DisplayProps) => {
  const name = typeof item === 'string' ? item : item.name
  const isEpic = name.startsWith('\\b')
  const displayName = isEpic ? name.slice(2) : name

  const labelStyle = isEpic ? 'labelType-epic' : 'labelType-label'

  const typeStyles = {
    badge: `h-[22px] p-0 border-none rounded-xs bg-${labelStyle}`,
    text: `text-${labelStyle}`,
  }

  const defaultStyles =
    variant === 'badge'
      ? 'py-1 pl-2 pr-1 font-EN-KR-caption-bold text-contents-onDarkPrimary'
      : 'font-EN-KR-body2-regular cursor-pointer'

  if (variant === 'text') {
    return (
      <button type="button" className={cn(typeStyles.text)}>
        <div className={cn(defaultStyles, className)}>{displayName}</div>
      </button>
    )
  }

  return (
    <Badge
      key={typeof item !== 'string' ? item.id : undefined}
      className={cn(
        'relative p-0 flex items-center border-none after:hover:bg-stateLayer-onDark-hovered after:hover:opacity-12 after:absolute after:w-full after:h-full hover:bg-tb-green-800 after:pointer-events-none',
        typeStyles.badge,
        isHighlighted && 'bg-tb-green-800',
        className,
      )}
    >
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className="w-fit py-1 pl-2 pr-1 outline-none focus:ring-0 focus:ring-ring focus:ring-offset-2 font-EN-KR-caption-bold text-contents-onDarkPrimary"
        onClick={() => {
          GlobalPubSub.publish(GlobalPubSub.Signals.SELECT_LABEL, displayName)
          GlobalPubSub.publish(GlobalPubSub.Signals.TOGGLE_LABEL_MANAGEMENT_MODAL, false)
        }}
      >
        {displayName}
      </Button>
      {onRemove && typeof item !== 'string' && (
        <Button
          type="button"
          size="icon"
          variant="ghost"
          className="w-[18px] h-[22px] py-1 px-0.5 outline-none focus:ring-0 focus:ring-ring focus:ring-offset-2"
          onClick={(e) => {
            e.stopPropagation()
            onRemove(item)
          }}
        >
          <img src="/images/label-delete-icon.svg" alt="delete label" />
        </Button>
      )}
    </Badge>
  )
}
